import React from "react"
import ChipSelect from "../common/ChipSelect"
import strings from "../../localization/strings"
import { ELanguage } from "../../models"
import { EnumValues } from "enum-values"
import _ from "lodash"
import AppStateStore from "../../stores/AppStateStore"
interface IProps {
    selectedLanguages: ELanguage[]
    readonly: boolean
    error: string
    handleChange(selectedLanguages: ELanguage[]): void
}

const LanguageSelectChip: React.SFC<IProps> = (props: IProps) => {
    const languageItems = EnumValues.getNamesAndValues(ELanguage).map(i => { return { Id: i.value as string, Name: i.name } })
    const selectedLanguageItems = props.selectedLanguages.map(i => languageItems.find(e => e.Name === EnumValues.getNameFromValue(ELanguage, i)))
    return (
        <ChipSelect
            readonly={props.readonly}
            title={strings.Languages}
            titleStyle={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13 }}
            allData={languageItems}
            linkedData={selectedLanguageItems}
            chipStyle={{ marginTop: 10, marginRight: 5, height: 35 }}
            addButtonStyle={{ height: 33, marginTop: 2, display: "inline-block" }}
            labelTextForSelect={strings.Select_Language}
            disAllowEmpty
            handleAddOne={item => {
                const selectedLanguages = _.cloneDeep(props.selectedLanguages)
                selectedLanguages.push(ELanguage[item.Name])
                props.handleChange(selectedLanguages)
            }}
            handleDeleteOne={item =>
                ELanguage[item.Name] === ELanguage.English ?
                    AppStateStore.setProgressSnackbarContent(strings.Cannot_remove_default_language_Eng) :
                    AppStateStore.setConfirmDialogContent({
                        content: strings.formatString(strings.Are_you_sure_you_want_to_remove_x_language, item.Name) as string,
                        confirm: () => {
                            let selectedLanguages = _.cloneDeep(props.selectedLanguages)
                            selectedLanguages = selectedLanguages.filter(i => i !== ELanguage[item.Name])
                            props.handleChange(selectedLanguages)
                        }
                    })
            }
            errorText={props.error}
        />
    )
}

export default LanguageSelectChip